// @flow
import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setMpin, logout, tokenAuth, toggleSignupDlg } from '../actions/auth';
import useFirebase from './firebase';

const useAuth = () => {
	const auth = useSelector((state) => state.auth);
	const { sessionId } = auth;
	const { mobile } = useSelector((state) => state.user || {});
	const dispatch = useDispatch();
	const [logEvent] = useFirebase();

	const setMpinCb = useCallback((mpin: string) => dispatch(setMpin(mpin, mobile)), [dispatch, mobile]);
	const logoutCb = useCallback(() => {
		dispatch(logout(sessionId));
		logEvent('logout', { source: 'user_action' });
	}, [dispatch, logEvent, sessionId]);

	const tokenAuthCb = useCallback((token: string) => dispatch(tokenAuth(token, sessionId)), [dispatch, sessionId]);
	
	const toggleSignupDlgCb = useCallback((state: boolean) => dispatch(toggleSignupDlg(state)), [dispatch]);

	return [auth, setMpinCb, logoutCb, tokenAuthCb, toggleSignupDlgCb];
};

export default useAuth;
